module.exports = "//cdn.livechat-static.com/webapp/img/automatic-message.svg?1c1e00da4ead08cfacbb59922116a4ed";